import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/smart-contract-runtime/page.tsx");
